// assets/faq-accordion.js
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.help-faqs').forEach(section => {
    const triggers = section.querySelectorAll('.faq-trigger');

    triggers.forEach(btn => {
      btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        const content = btn.nextElementSibling;
        const icon = btn.querySelector('i');

        if (isOpen) {
          btn.setAttribute('aria-expanded', 'false');
          icon.className = 'fas fa-plus';
          content.style.maxHeight = null;
        } else {
          btn.setAttribute('aria-expanded', 'true');
          icon.className = 'fas fa-minus';
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  });
});
